import React from 'react'

import { Divider, Toggle } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, func, oneOf, string,
} from 'prop-types'

import { MODE } from 'Pods/LazyLoaded/AiSignInModal/constants'

import EmailField from './Components/EmailField/EmailField'
import Footer from './Components/Footer/Footer'
import Header from './Components/Header/Header'
import SocialButtons from './Components/SocialButtons/SocialButtons'
import TermsNotice from './Components/TermsNotice/TermsNotice'

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

function AuthStep({
  mode,
  email,
  optIn,
  onEmailChange,
  onOptInChange,
  onSubmit,
  onSocial,
  onSwitchMode,
}) {
  const isSignup = mode === MODE.SIGNUP
  const isEmailValid = EMAIL_REGEX.test(email.trim())

  const handleSubmit = (event) => {
    event.preventDefault()
    if (isEmailValid) {
      onSubmit()
    }
  }

  return (
    <form className="ai-sign-in-modal__auth" onSubmit={handleSubmit} noValidate>
      <Header isSignup={isSignup} />
      <SocialButtons onSocial={onSocial} />
      <Divider customClass="ai-sign-in-modal__divider" childrenPosition="center">
        <span className="ai-sign-in-modal__divider-text cgt-caption-semibold">or</span>
      </Divider>
      <EmailField value={email} onChange={onEmailChange} />
      {isSignup && (
        <Toggle
          id="ai-sign-in-opt-in"
          isChecked={optIn}
          onChange={(_, checked) => onOptInChange(checked)}
          label="Get product updates, community news and offers."
          labelClassName="ai-sign-in-modal__opt-in-label cgt-body-base"
        />
      )}
      <Footer isSignup={isSignup} canSubmit={isEmailValid} onSwitchMode={onSwitchMode} />
      {isSignup && <TermsNotice />}
    </form>
  )
}

AuthStep.propTypes = {
  mode: oneOf([MODE.SIGNUP, MODE.LOGIN]).isRequired,
  email: string.isRequired,
  optIn: bool.isRequired,
  onEmailChange: func.isRequired,
  onOptInChange: func.isRequired,
  onSubmit: func.isRequired,
  onSocial: func.isRequired,
  onSwitchMode: func.isRequired,
}

export default AuthStep
